import { createSlice } from '@reduxjs/toolkit';
import { initialState, logOut, setCredentials } from './AuthSlice';

export const authSessionSlice = createSlice({
  name: 'authSession',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setCredentials, (state, action) => {
      if (action.payload.rememberMe === false) {
        state.userName = action.payload.response.userName;
        state.roles = [];
        state.token = action.payload.response.token;
        state.rememberMe = action.payload.rememberMe;
        state.refreshToken = action.payload.response.refreshToken;
      }
    });
    builder.addCase(logOut, (state, action) => {
      state.userName = '';
      state.roles = [];
      state.token = null;
      state.refreshToken = null;
      state.rememberMe = false;
    });
  },
});

export default authSessionSlice.reducer;
